import React from 'react';
import styled from 'styled-components';

import { AnimatedLogo, LogoColorVariantEnum, LogoSizeEnum } from '../../atoms/animated-logo';
import { ColorVariantEnum, FinePrintEnum, MarginSizeEnum, Text } from '../../atoms/text';

const FoleonLoaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: auto;
`;

const AnimatedLogoContainer = styled.div`
	margin-bottom: 16px;
`;

interface IFoleonLoader {
	text?: string;
	logoSize?: LogoSizeEnum;
	logoColorVariant?: LogoColorVariantEnum;
}

export const FoleonLoader: React.FunctionComponent<IFoleonLoader> = ({ text, logoSize, logoColorVariant }) => (
	<FoleonLoaderContainer>
		<AnimatedLogoContainer>
			<AnimatedLogo
				size={logoSize || LogoSizeEnum.LARGE}
				colorVariant={logoColorVariant || LogoColorVariantEnum.DARK}
			/>
		</AnimatedLogoContainer>
		{text && (
			<Text.FinePrint colorVariant={ColorVariantEnum.LIGHT} type={FinePrintEnum.TINY} margin={MarginSizeEnum.NONE}>
				{text}
			</Text.FinePrint>
		)}
	</FoleonLoaderContainer>
);
